<div class="oms-environment">{{environment}}</div>